<div
  class="order-request-insight order-request-insight--loading"
  *ngIf="isLoading && !banner"
  aria-live="polite"
>
  <p class="order-request-insight__loading-copy">Loading history...</p>
</div>
<!-- CWS-1650: status strip alone when there is no wash history to show under it. -->
<div
  *ngIf="statusStrip && !banner && !isLoading"
  class="order-request-insight order-request-insight--status"
  [ngClass]="'order-request-insight--status-' + statusStrip.tone"
>
  <app-membership-status-strip class="order-request-insight__status-head" [strip]="statusStrip" />
  <app-membership-status-strip
    *ngIf="statusStrip.suggestion"
    class="order-request-insight__status-suggestion"
    [strip]="statusStrip"
    section="suggestion"
  />
</div>
<div
  class="order-request-insight"
  *ngIf="banner as insight"
  [class.order-request-insight--status]="!!statusStrip"
  [ngClass]="statusStrip ? 'order-request-insight--status-' + statusStrip.tone : ''"
>
  <app-membership-status-strip
    *ngIf="statusStrip"
    class="order-request-insight__status-head"
    [strip]="statusStrip"
  />
  <div class="order-request-insight__header">
    <div class="order-request-insight__header-main">
      <div class="order-request-insight__title-row">
        <h3 class="order-request-insight__package-title">{{ insight.packageName }}</h3>
        <span class="order-request-insight__recent-badge">Recent visit</span>
      </div>
      <p class="order-request-insight__meta">
        <span>Last Visit {{ insight.lastVisit }}</span>
        <span class="order-request-insight__meta-sep" aria-hidden="true"></span>
        <span>{{ insight.washType }}</span>
      </p>
      <div
        class="order-request-insight__rating"
        role="img"
        [attr.aria-label]="
          insight.feedbackRating !== null
            ? insight.feedbackRating + ' out of 5 stars'
            : 'No feedback rating'
        "
      >
        <span
          *ngFor="let star of starValues"
          class="order-request-insight__star"
          [class.order-request-insight__star--filled]="isStarFilled(star)"
          aria-hidden="true"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12 2.6l2.9 5.9 6.5.95-4.7 4.6 1.1 6.45L12 17.45 6.2 20.5l1.1-6.45-4.7-4.6 6.5-.95z"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="order-request-insight__header-actions">
      <span class="order-request-insight__rewash-countdown" *ngIf="showRewashCountdown">
        {{ formattedRewashAvailableUntil }}
      </span>
      <div class="order-request-insight__action-buttons">
        <button
          *ngIf="showRewashCta"
          type="button"
          class="order-request-insight__rewash-btn"
          (click)="onHeaderRewashClick()"
        >
          Rewash
        </button>
        <button
          type="button"
          class="order-request-insight__visits-toggle"
          (click)="historyToggle.emit()"
          [attr.aria-expanded]="historyExpanded"
        >
          {{ visitsTotalLabel }}
          <svg
            class="chevron"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              *ngIf="!historyExpanded"
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              *ngIf="historyExpanded"
              d="M18 15l-6-6-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <app-membership-status-strip
    *ngIf="statusStrip?.suggestion"
    class="order-request-insight__status-suggestion"
    [strip]="statusStrip!"
    section="suggestion"
  />

  <div class="order-request-history-panel" *ngIf="historyExpanded">
    <h4 class="order-request-history-panel__title">Wash history</h4>
    <div
      class="order-request-history-panel__card"
      [class.order-request-history-panel__card--loading]="isLoading"
    >
      <div class="order-request-history-panel__table-wrap">
        <table class="order-request-history-table">
          <thead>
            <tr>
              <th scope="col">Visit Date</th>
              <th scope="col">Wash Type</th>
              <th scope="col">Package</th>
              <th scope="col">Plate</th>
              <th scope="col" class="order-request-history-table__action-heading">
                <span class="sr-only">Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of insight.historyRows">
              <td>{{ row.visitDate }}</td>
              <td>{{ row.washType }}</td>
              <td>{{ row.packageName }}</td>
              <td>{{ row.plate }}</td>
              <td class="order-request-history-table__action">
                <ng-container [ngSwitch]="rowActionKind(row)">
                  <button
                    *ngSwitchCase="'rewash_button'"
                    type="button"
                    class="order-request-history-table__rewash-btn"
                    (click)="onRowRewashClick(row)"
                  >
                    Rewash
                  </button>
                  <span
                    *ngSwitchCase="'rewash_label'"
                    class="order-request-history-table__action-label order-request-history-table__action-label--rewash"
                  >
                    Rewash
                  </span>
                  <span
                    *ngSwitchCase="'scheduled'"
                    class="order-request-history-table__action-label order-request-history-table__action-label--muted"
                  >
                    Scheduled
                  </span>
                  <span
                    *ngSwitchCase="'redeemed'"
                    class="order-request-history-table__action-label order-request-history-table__action-label--muted"
                  >
                    Redeemed
                  </span>
                  <span
                    *ngSwitchDefault
                    class="order-request-history-table__action-label order-request-history-table__action-label--muted"
                  >
                    Completed
                  </span>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <app-pagination-bar
        *ngIf="historyPaginationData as paginationData"
        class="order-request-history-pager"
        testId="order-request-history"
        [paginationData]="paginationData"
        [itemsPerPageOptions]="pageSizeOptions"
        (pageChange)="pageChange.emit($event)"
        (itemsPerPageChange)="pageSizeChange.emit($event)"
      />
    </div>
  </div>
</div>
